import { Telegram, Vkontakte } from 'src/components/Icons';
import { Link } from 'src/uikit/Link';

import s from './SocialButtonsShare.module.scss';

export function SocialButtonsShare({
  linkForSharing,
}: {
  linkForSharing: string;
}) {
  // https://www.facebook.com/sharer/sharer.php?u=https://www.websiteplanet.com

  return (
    <div className={s.root}>
      <Link
        className={s.button}
        href={`https://vk.com/share.php?url=${linkForSharing}`}
        target="_blank"
        analyticsOptions={{
          action: '`https://vk.com/share.php?url=${linkForSharing}`',
          clickZone: 'body',
          clickElement: 'buttonclick',
          clickContent: 'vk-icon',
          uniqueId: 'vk-icon',
          transitionType: 'outside-link',
          clickZoneCategory: 'site-body',
          transitionUrl: `https://vk.com/share.php?url=${linkForSharing}`,
          transitionTypeMetrics: 'external',
        }}
      >
        <Vkontakte className={s.vk} />
      </Link>
      <Link
        className={s.button}
        href={`https://telegram.me/share/url?url=${linkForSharing}`}
        target="_blank"
        analyticsOptions={{
          action: `https://telegram.me/share/url?url=${linkForSharing}`,
          clickZone: 'body',
          clickElement: 'buttonclick',
          clickContent: 'tg-icon',
          uniqueId: 'tg-icon',
          transitionType: 'outside-link',
          clickZoneCategory: 'site-body',
          transitionUrl: `https://telegram.me/share/url?url=${linkForSharing}`,
          transitionTypeMetrics: 'external',
        }}
      >
        <Telegram className={s.tg} />
      </Link>
    </div>
  );
}
